import { render, staticRenderFns } from "./UserDetailReferralsTab.vue?vue&type=template&id=f6e07386&scoped=true&lang=pug&"
import script from "./UserDetailReferralsTab.vue?vue&type=script&lang=js&"
export * from "./UserDetailReferralsTab.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailReferralsTab.vue?vue&type=style&index=0&id=f6e07386&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e07386",
  null
  
)

export default component.exports